exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-box[data-v-40d37de4]{line-height:100%}.footer-logo-container>img[data-v-40d37de4]{max-height:48px;width:auto}", ""]);

// exports
